export default __webpack_public_path__ + "static/media/St Clair College.46b8aea5.png";